"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.number.constructor");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.bmFormEventDispatcher = bmFormEventDispatcher;
exports.bmFormEventListener = bmFormEventListener;
exports.collectChanges = collectChanges;
exports.applyChanges = applyChanges;
exports.patchFormValues = patchFormValues;
exports.patchFormValue = patchFormValue;
exports._resolveDependentFields = _resolveDependentFields;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _for = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/symbol/for"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _dotPropImmutable = require("dot-prop-immutable");

var _utils = require("../../utils");

var _itemFactory = require("./items/item-engine/item-factory");

var _bmFormValues = require("./bm-form-values");

var _itemRenderer = require("./items/item-engine/item-renderer");

function bmFormEventDispatcher(clazz) {
  var _temp;

  return _temp = /*#__PURE__*/function (_clazz) {
    (0, _inherits2.default)(_temp, _clazz);

    var _super = (0, _createSuper2.default)(_temp);

    function _temp() {
      var _context;

      var _this;

      (0, _classCallCheck2.default)(this, _temp);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
      _this.mixinType = (0, _for.default)('BmFormEventDispatcherMixin');
      return _this;
    }

    (0, _createClass2.default)(_temp, [{
      key: "dispatchBmFormEvent",
      value: function dispatchBmFormEvent(detail) {
        return this.dispatchEvent(new CustomEvent('bm-form-event', {
          detail: detail,
          bubbles: true,
          composed: true
        }));
      }
    }]);
    return _temp;
  }(clazz), _temp;
}

function bmFormEventListener(clazz) {
  var _temp2;

  return _temp2 = /*#__PURE__*/function (_clazz2) {
    (0, _inherits2.default)(_temp2, _clazz2);

    var _super2 = (0, _createSuper2.default)(_temp2);

    function _temp2() {
      var _context2, _context3, _context4;

      var _this2;

      (0, _classCallCheck2.default)(this, _temp2);
      _this2 = _super2.call(this);
      _this2.mixinType = (0, _for.default)('BmFormEvenListenerMixin');
      _this2.collectChanges = collectChanges;
      _this2.valuedFields = _bmFormValues.valuedFields;
      _this2.applyChanges = applyChanges;
      _this2.patchFormValues = patchFormValues;
      _this2.patchFormValue = patchFormValue;
      _this2._resolveDependentFields = _resolveDependentFields;

      _this2.addBmFormEventListener('changed', (0, _bind.default)(_context2 = _this2.handleBmFormChangedEvent).call(_context2, (0, _assertThisInitialized2.default)(_this2)));

      _this2.addBmFormEventListener('touched', (0, _bind.default)(_context3 = _this2.handleBmFormTouchedEvent).call(_context3, (0, _assertThisInitialized2.default)(_this2)));

      _this2.addBmFormEventListener('init', (0, _bind.default)(_context4 = _this2.handleBmFormInitEvent).call(_context4, (0, _assertThisInitialized2.default)(_this2)));

      return _this2;
    }

    (0, _createClass2.default)(_temp2, [{
      key: "addBmFormEventListener",
      value: function addBmFormEventListener(type, cb) {
        var _this3 = this;

        return this.addEventListener('bm-form-event', function (_evt) {
          return _this3.handleBmFormEvent(_evt, type, cb);
        }, {
          passive: true
        });
      }
    }, {
      key: "handleBmFormEvent",
      value: function handleBmFormEvent(_evt, type, cb) {
        var evt = _evt;

        if (evt.detail.type === type) {
          cb(evt);
        }
      }
    }, {
      key: "handleBmFormInitEvent",
      value: function handleBmFormInitEvent(evt) {
        var newRootFormInfo = this.info;

        if (this.info.root.dependencyMap) {
          newRootFormInfo = this.info.root.dependencyMap.initialize(this.info);
        }

        evt.detail.data = {
          currentValue: (0, _bmFormValues.getValue)(newRootFormInfo),
          previousValue: (0, _bmFormValues.getValue)(this.info)
        };
        this.info = newRootFormInfo;
      }
    }, {
      key: "handleBmFormChangedEvent",
      value: function handleBmFormChangedEvent(evt) {
        var changes = evt.detail.data.changes || (0, _defineProperty2.default)({}, this._getFullyQualifiedName(evt), {
          value: evt.detail.data.currentValue
        });
        var rootFormInfo = this.info;
        var newRootFormInfo = this.patchFormValues(rootFormInfo, changes);
        evt.detail.data = {
          currentValue: (0, _bmFormValues.getValue)(newRootFormInfo),
          previousValue: (0, _bmFormValues.getValue)(this.info)
        };
        this.info = newRootFormInfo;
      }
    }, {
      key: "handleBmFormTouchedEvent",
      value: function handleBmFormTouchedEvent(evt) {
        var fqnDotPath = this._getDotPath(evt);

        var _get = (0, _dotPropImmutable.get)(this.info, fqnDotPath),
            fullyResolvedName = _get.fullyResolvedName;

        var newRootFormInfo = this.patchFormValue(this.info, fullyResolvedName, {
          propPath: 'touched',
          value: true
        });
        this.info = newRootFormInfo;
      }
    }, {
      key: "_getFullyQualifiedName",
      value: function _getFullyQualifiedName(evt) {
        var composedPath = evt.composedPath();
        var bmItemElement = (0, _find.default)(composedPath).call(composedPath, function (target) {
          return target instanceof _itemRenderer.BmItemElement;
        });
        return bmItemElement.info.fullyResolvedName;
      }
    }, {
      key: "_getDotPath",
      value: function _getDotPath(evt) {
        var dotPath = (0, _utils.dotPathFromAncestry)(this._getFullyQualifiedName(evt));
        return dotPath;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          items: {
            type: Object,
            attribute: false,
            reflect: false
          },
          layout: {
            type: Object,
            attribute: false,
            reflect: false
          },
          data: {
            type: Object,
            attribute: false,
            reflect: false
          },
          disabled: {
            type: Boolean
          }
        };
      }
    }]);
    return _temp2;
  }(clazz), _temp2;
}

var defaultResolver = function defaultResolver(v, _) {
  return v;
};

function collectChanges(root, itemFqn, value) {
  var changeMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var valueResolver = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultResolver;

  if (Boolean(value) && (0, _typeof2.default)(value) === 'object') {
    var _context5;

    (0, _forEach.default)(_context5 = (0, _entries.default)(value)).call(_context5, function (_ref2) {
      var _context7;

      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          name = _ref3[0],
          val = _ref3[1];

      var itemName;

      if ((0, _isArray.default)(value)) {
        var _context6;

        var varForm = (0, _utils.getItemFromPath)(root, itemFqn);
        var t = (0, _sort.default)(_context6 = (0, _entries.default)(varForm.options.items)).call(_context6, function (_ref4, _ref5) {
          var _ref6 = (0, _slicedToArray2.default)(_ref4, 1),
              i1 = _ref6[0];

          var _ref7 = (0, _slicedToArray2.default)(_ref5, 1),
              i2 = _ref7[0];

          return Number(i1) - Number(i2);
        });
        itemName = t[Number(name)][0];
      } else {
        itemName = name;
      }

      var fqn = (0, _concat.default)(_context7 = "".concat(itemFqn ? itemFqn + '.' : '')).call(_context7, itemName);
      collectChanges(root, fqn, val, changeMap, valueResolver);
    });
  } else {
    changeMap[itemFqn] = {
      value: valueResolver(value, itemFqn)
    };
  }

  return changeMap;
}

function applyChanges(rootFormInfo, fieldFqns) {
  for (var _len3 = arguments.length, fieldChanges = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    fieldChanges[_key3 - 2] = arguments[_key3];
  }

  return (0, _reduce.default)(fieldChanges).call(fieldChanges, function (acc, change) {
    var changes = (0, _reduce.default)(fieldFqns).call(fieldFqns, function (changes, fqn) {
      changes[fqn] = change;
      return changes;
    }, {});
    return patchFormValues(acc, changes);
  }, rootFormInfo);
}

function patchFormValues(rootFormInfo, changes) {
  var _context8;

  var _patchFormValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : patchFormValue;

  return (0, _reduce.default)(_context8 = (0, _entries.default)(changes)).call(_context8, function (newRootFormInfo, _ref8) {
    var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
        fqn = _ref9[0],
        patchOpts = _ref9[1];

    var updatedForm = _patchFormValue(newRootFormInfo, fqn, patchOpts);

    return updatedForm;
  }, rootFormInfo);
}

function patchFormValue(rootFormInfo, fullyQualifiedName, _ref10) {
  var propPath = _ref10.propPath,
      value = _ref10.value,
      valuePath = _ref10.valuePath;

  var __resolveDependentFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _resolveDependentFields;

  var fqnDotPath = (0, _utils.dotPathFromAncestry)(fullyQualifiedName);
  var itemInfo = (0, _dotPropImmutable.get)(rootFormInfo, fqnDotPath);

  if (!itemInfo) {
    throw new Error("Could not find item: ".concat(fullyQualifiedName));
  }

  var newValue;

  if (valuePath) {
    if ((0, _includes.default)(valuePath).call(valuePath, 'parent.') && _utils.invalidParents.invalid) {
      (0, _utils.setParents)(rootFormInfo);
    }

    var itemOrProperty = (0, _dotPropImmutable.get)(itemInfo, valuePath);
    newValue = Boolean(itemOrProperty) && (0, _bmFormValues.canHaveValue)(itemOrProperty) ? (0, _bmFormValues.getValue)(itemOrProperty) : itemOrProperty;
  } else {
    newValue = value;
  }

  propPath = propPath || 'value';
  var prevValue = (0, _dotPropImmutable.get)(itemInfo, propPath);

  if (prevValue !== newValue) {
    var newItem = (0, _dotPropImmutable.set)(itemInfo, propPath, newValue);

    if (propPath === 'value') {
      newItem = (0, _dotPropImmutable.set)(newItem, 'dirty', true);
    }

    rootFormInfo = (0, _dotPropImmutable.set)(rootFormInfo, fqnDotPath, newItem);

    if ((0, _itemFactory.isAvailable)(newItem) && !newItem.disabled) {
      rootFormInfo = __resolveDependentFields(rootFormInfo, fullyQualifiedName);
    }

    _utils.invalidParents.invalid = true;
  }

  return rootFormInfo;
}

function _resolveDependentFields(rootFormInfo, fullyResolvedFieldName) {
  return rootFormInfo.root.dependencyMap.updateDependents(rootFormInfo, fullyResolvedFieldName);
}
